/* Build links from actual rendered sections; leave every themed description intact. */
(() => {
  const main = document.getElementById('MainContent');
  if (!main || window.CgauProductPolish) return;
  const navSelector = '[data-cgau-product-navigation]';
  const storySelector = '.text-block--text_iBUwPE, .text-block[class*="__text_iBUwPE"]';
  const watchedSelector = `${navSelector}, [id$="__cgau_description"], ${storySelector}, .product-specifications, #cgau-product-reviews, #judgeme_product_reviews`;

  const usable = (target) => target && target.isConnected && !target.closest('[hidden], [aria-hidden="true"]');
  const identify = (target, fallbackId) => {
    if (!target.id) target.id = fallbackId;
    target.classList.add('cgau-product-jump-target');
    return target.id;
  };
  const targetsFor = (nav) => {
    const items = [];
    const overview = document.getElementById(nav.dataset.overviewId);
    if (usable(overview)) items.push({ label: 'Buying options', target: overview, id: overview.id });

    const defaultStory = main.querySelector('[id$="__cgau_description"]')?.querySelector(storySelector);
    const alternateStory = nav.dataset.productTemplate === 'e30-v7'
      ? main.querySelector('.product-recommendations')?.querySelector(storySelector) : null;
    const story = defaultStory || alternateStory;
    if (usable(story) && story.textContent.trim()) items.push({ label: 'Product story', target: story, id: 'cgau-product-story' });

    const specifications = main.querySelector('.product-specifications');
    if (usable(specifications)) items.push({ label: 'Specifications', target: specifications, id: 'cgau-product-specifications' });
    const reviews = document.getElementById('cgau-product-reviews') || document.getElementById('judgeme_product_reviews');
    if (usable(reviews)) items.push({ label: 'Customer reviews', target: reviews, id: 'cgau-product-reviews' });
    return items;
  };

  const refresh = () => {
    main.querySelectorAll(navSelector).forEach((nav) => {
      const items = targetsFor(nav).map((item) => ({ ...item, id: identify(item.target, item.id) }));
      const signature = items.map((item) => `${item.id}:${item.label}`).join('|');
      if (nav.dataset.jumpSignature !== signature) {
        const links = items.map((item) => {
          const link = document.createElement('a');
          link.href = `#${item.id}`;
          link.textContent = item.label;
          link.dataset.cgauJump = item.id;
          return link;
        });
        nav.replaceChildren(...links);
        nav.dataset.jumpSignature = signature;
      }
      nav.hidden = items.length === 0;
    });
  };

  main.addEventListener('click', (event) => {
    const link = event.target.closest?.(`${navSelector} a[data-cgau-jump]`);
    if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    let target = document.getElementById(link.dataset.cgauJump);
    if (!usable(target)) {
      const item = targetsFor(link.closest(navSelector)).find((item) => item.label === link.textContent.trim());
      if (!item) { event.preventDefault(); refresh(); return; }
      target = item.target;
      const id = identify(target, item.id);
      // Keep this link connected until its native fragment action has completed.
      link.href = `#${id}`;
      link.dataset.cgauJump = id;
    }
    // Native fragment navigation owns scrolling and history; focus follows the destination.
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });

  let scheduled = false;
  const scheduleRefresh = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; refresh(); });
  };
  if ('MutationObserver' in window) {
    const observer = new MutationObserver((changes) => {
      const relevant = changes.some((change) => change.type === 'attributes'
        ? change.target.matches(watchedSelector)
        : [...change.addedNodes, ...change.removedNodes].some((node) =>
          node.nodeType === 1 && (node.matches(watchedSelector) || node.querySelector(watchedSelector))
        ));
      if (relevant) scheduleRefresh();
    });
    // Hydration can strip an injected ID without replacing its node. Ignore animation attributes.
    observer.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['id'] });
  }
  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('shopify:section:unload', scheduleRefresh);
  window.CgauProductPolish = { refresh };
  refresh();
})();
